import { Check, X } from 'lucide-react'

export const QualificationSection = () => {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32 border-t border-gray-100">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading font-black text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-none text-black uppercase mb-10 md:mb-16 text-balance">
            Não perca meu tempo.
            <br className="hidden sm:block" />
            <span className="text-red-600 block sm:inline mt-2 sm:mt-0">
              E nem o seu.
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 text-left mb-10 md:mb-16">
            {/* NOT FOR */}
            <div className="bg-red-50 p-6 md:p-10 rounded-2xl md:rounded-3xl border-2 border-red-100 hover:border-red-200 transition-colors shadow-sm">
              <h3 className="font-heading font-bold text-red-600 text-xl md:text-2xl mb-6 uppercase tracking-wider flex items-center gap-3">
                <X className="w-6 h-6 md:w-8 md:h-8 stroke-[3]" />
                <span className="text-balance">A Elite NÃO é para:</span>
              </h3>
              <ul className="space-y-4 md:space-y-6">
                {[
                  'Curiosos sem ambição de crescimento real.',
                  'Quem busca dinheiro fácil sem trabalho duro.',
                  'Pessoas que têm medo de investir no próprio futuro.',
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 md:gap-4">
                    <div className="mt-2 min-w-[6px] h-[6px] rounded-full bg-red-400 shrink-0" />
                    <span className="font-sans font-medium text-base md:text-lg text-gray-900 leading-snug">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* IS FOR */}
            <div className="bg-green-50 p-6 md:p-10 rounded-2xl md:rounded-3xl border-2 border-green-100 hover:border-green-200 transition-colors shadow-sm">
              <h3 className="font-heading font-bold text-[#00AA00] text-xl md:text-2xl mb-6 uppercase tracking-wider flex items-center gap-3">
                <Check className="w-6 h-6 md:w-8 md:h-8 stroke-[4]" />
                <span className="text-balance">A Elite É para:</span>
              </h3>
              <ul className="space-y-4 md:space-y-6">
                {[
                  'Visionários que querem dominar o mercado.',
                  'Quem entende que o jogo é de longo prazo.',
                  'Executores com fome de liberdade financeira.',
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 md:gap-4">
                    <div className="mt-2 min-w-[6px] h-[6px] rounded-full bg-green-500 shrink-0" />
                    <span className="font-sans font-medium text-base md:text-lg text-gray-900 leading-snug">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <p className="font-heading font-black text-lg sm:text-2xl md:text-3xl text-red-600 uppercase leading-tight animate-pulse max-w-3xl mx-auto text-balance px-2">
            Se você não tem fome de mudar de vida, saia agora.
          </p>
        </div>
      </div>
    </section>
  )
}
